












































































































































































































import { defineComponent, onMounted, computed, ref } from "@vue/composition-api";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import Icon from "@/components/Icon.vue";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { TimeAxisType } from "@/gql/types";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { UseLoading } from "@/common/composition/loading";
import * as api from "./data/api";
import { DownloadService } from "@/common/download.service";
import { SharedState } from "@/common/state";
import axios from "axios";
import Spinner from "@/components/Spinner.vue";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { trackReportEvent } from "../data/report-analytics";
import ManagementReportCard from "./ManagementReportCard.vue";
import { MANAGEMENT_DECKS } from "@/views/reports/data/pdf/aggregation-timeframes";
type TimeFrameSelection = {
  id: string;
  name: string;
  type: TimeAxisType;
  value: number;
};

export default defineComponent({
  components: { DropDownSimple, Spinner, Icon, ManagementReportCard },
  setup() {
    const [
      from_time_frames,
      selected_from_time_frame,
      set_selected_from_time_frame,
      init_time_frames,
    ] = UseDropdownItems<TimeFrameSelection>([]);

    const [
      domain_time_frames,
      selected_domain_time_frame,
      set_selected_domain_time_frame,
      init_domain_time_frames,
    ] = UseDropdownItems<TimeFrameSelection>([]);

    const [
      insights_time_frames,
      selected_insights_time_frame,
      set_selected_insights_time_frame,
      init_insights_time_frames,
    ] = UseDropdownItems<TimeFrameSelection>([]);

    const [is_generating, set_is_generating] = UseLoading(false).as_arr();
    const [is_generating_domain, set_is_generating_domain] =
      UseLoading(false).as_arr();
    const [is_generating_insights, set_is_generating_insights] =
      UseLoading(false).as_arr();

    const org_alias = ref("");

    /**
     * Both single-file labeling reports run the same way: ask for the blob
     * ref, download it, and report the two analytics events around it. They
     * differ only in which report the generator renders, which is the
     * template id, and in what the file and the events are called.
     */
    const download_labeling_report = async ({
      time_frame,
      report_name,
      file_prefix,
      set_loading,
      template_id,
    }: {
      time_frame: TimeFrameSelection | null | undefined;
      report_name: string;
      file_prefix: string;
      set_loading: (value: boolean) => void;
      template_id?: string;
    }) => {
      if (!time_frame) return;
      set_loading(true);
      const months_ago = time_frame.value;
      const res1 = await api.get_external_labeling_report_ref({
        months_ago,
        template_id,
      });
      if (res1.success && res1.value.has_labeling) {
        const { blobKey, containerName } = res1.value;
        const url = `${axios.defaults.baseURL}/extproxy/integrations/status/blob-contents?containerName=${containerName}&blobKey=${blobKey}`;
        const [, download] = DownloadService.from_web.pdf({
          authorization: SharedState.loggedUser.value.authorization,
          use_auth: true,
          fileName: file_prefix + time_frame.name + ".pdf",
          filePath: url,
        });
        const event = {
          report_name,
          report_type: "executive" as const,
          report_subtype: "external_labeling_pdf",
          entity_type: "labels",
          filters: {
            time_frame: time_frame.name,
            months_ago,
            external_label_provider: "mip",
            aggregation: "external-label-by-label",
            ...(template_id ? { template: template_id } : {}),
          },
          source: "executive_reports",
        };
        trackReportEvent("generated", event);
        await download();
        trackReportEvent("downloaded", event);
      } else if (res1.success && !res1.value.has_labeling) {
        UseToast().show({
          type: ToastType.INFO,
          msg: res1.value.msg || "no labeling performed during given period.",
          duration: 6000,
        });
      } else {
        UseToast().show({
          type: ToastType.ALERT,
          msg: "Something went wrong",
          duration: 3000,
        });
      }
      set_loading(false);
    };

    const generate_external_labeling_report = () =>
      download_labeling_report({
        time_frame: selected_from_time_frame.value,
        report_name: "Cognni Labeling",
        file_prefix: "external_labeling_report_",
        set_loading: set_is_generating,
      });

    /**
     * Ami's "label status report with insights": the labeling report the MIP
     * work added, as its own block beside the report it used to replace.
     *
     * It asks for "extended-report", not the labeling report's own id, because
     * integrations-manager answers 400 for any id it does not already know.
     * On the single-report route the adapter reads that id as the labeling
     * report; see SINGLE_REPORT_TEMPLATE_ALIASES in cx-report-adapter. The
     * card above sends no id, which integrations-manager turns into
     * "short-report", so it keeps the old report.
     */
    const generate_label_status_report = () =>
      download_labeling_report({
        time_frame: selected_insights_time_frame.value,
        report_name: "Label Status Report with Insights",
        file_prefix: "label_status_report_with_insights_",
        set_loading: set_is_generating_insights,
        template_id: "extended-report",
      });

    const generate_domain_separated_report = async () => {
      set_is_generating_domain(true);
      const months_ago = selected_domain_time_frame.value!.value;
      const res1 = await api.get_external_labeling_domain_separated_report_ref({
        months_ago,
        orgAlias: SharedState.loggedUser.value.orgName || org_alias.value,
      });
      if (res1.success && res1.value.has_labeling) {
        const { blobKey, containerName } = res1.value;
        const url = `${axios.defaults.baseURL}/extproxy/integrations/status/blob-contents?containerName=${containerName}&blobKey=${blobKey}`;
        const [, download] = DownloadService.from_web.zip({
          authorization: SharedState.loggedUser.value.authorization,
          use_auth: true,
          fileName:
            "In Motion Labeling Report_" +
            (selected_domain_time_frame.value?.name || "Period") +
            ".zip",
          filePath: url,
        });
        trackReportEvent("generated", {
          report_name: "Cognni Labeling by Domains",
          report_type: "executive",
          report_subtype: "external_labeling_domains_zip",
          entity_type: "domains",
          filters: {
            time_frame: selected_domain_time_frame.value?.name,
            months_ago,
            external_label_provider: "mip",
            aggregation: "external-label-by-label",
            template: "extended-report",
          },
          source: "executive_reports",
        });
        await download();
        trackReportEvent("downloaded", {
          report_name: "Cognni Labeling by Domains",
          report_type: "executive",
          report_subtype: "external_labeling_domains_zip",
          entity_type: "domains",
          filters: {
            time_frame: selected_domain_time_frame.value?.name,
            months_ago,
            external_label_provider: "mip",
            aggregation: "external-label-by-label",
            template: "extended-report",
          },
          source: "executive_reports",
        });
      } else if (res1.success && !res1.value.has_labeling) {
        UseToast().show({
          type: ToastType.INFO,
          msg: res1.value.msg || "no labeling performed during given period.",
          duration: 6000,
        });
      } else {
        UseToast().show({
          type: ToastType.ALERT,
          msg: "Something went wrong",
          duration: 3000,
        });
      }
      set_is_generating_domain(false);
    };

    const create_month_note = (selection_ref: {
      value: TimeFrameSelection | null | undefined;
    }) =>
      computed(() => {
        const selection = selection_ref.value;
        if (!selection || selection.value !== 0) {
          return "";
        }

        const today = new Date();
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const freezeEnd = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1
        );

        if (freezeEnd < monthStart) {
          return "Covers no days yet this month. Daily data is added after each day completes.";
        }

        const monthLabel = monthStart.toLocaleDateString(undefined, {
          month: "short",
        });
        return `Covers ${monthStart.getDate()}–${freezeEnd.getDate()} ${monthLabel}`;
      });

    const current_month_note = create_month_note(selected_from_time_frame);
    const domain_current_month_note = create_month_note(selected_domain_time_frame);
    const insights_current_month_note = create_month_note(
      selected_insights_time_frame
    );

    const fetch_org_alias = async () => {
      const orgId = (SharedState.loggedUser.value as any)?.orgId;
      if (!orgId) {
        return;
      }
      const res = await api.get_organizations_supplementary_data({ orgId });
      if (res.success && res.value.alias) {
        org_alias.value = res.value.alias;
      }
    };

    onMounted(() => {
      const time_frames =
        data_sources_state.ext.get_in_motion_source_time_frames("motion_365");
      const monthly_frames = time_frames.slice(2, 5);
      const limited_frames = monthly_frames.map((f, index) => {
        return {
          id: f.displayName,
          name: f.displayName,
          type: f.type,
          value: index,
        };
      });
      init_time_frames(limited_frames);
      if (limited_frames.length > 0) {
        set_selected_from_time_frame(limited_frames[0].id);
      }
      init_domain_time_frames(limited_frames);
      if (limited_frames.length > 0) {
        set_selected_domain_time_frame(limited_frames[0].id);
      }
      init_insights_time_frames(limited_frames);
      if (limited_frames.length > 0) {
        set_selected_insights_time_frame(limited_frames[0].id);
      }
      fetch_org_alias();
    });

    const months_scope_note =
      "This report displays data for the current month and the previous two months only.";

    return {
      management_decks: MANAGEMENT_DECKS,
      domain_time_frames,
      from_time_frames,
      insights_time_frames,
      is_generating,
      is_generating_domain,
      is_generating_insights,
      org_alias,
      generate_domain_separated_report,
      set_selected_from_time_frame,
      set_selected_domain_time_frame,
      set_selected_insights_time_frame,
      selected_from_time_frame,
      selected_domain_time_frame,
      selected_insights_time_frame,
      generate_external_labeling_report,
      generate_label_status_report,
      current_month_note,
      domain_current_month_note,
      insights_current_month_note,
      months_scope_note,
    };
  },
});
